export const environment = {
  productionMode: true,
  baseApiUrl: 'https://api.dealers-stock.jp/v1',
  GMO_ShopID: '9200003773203',
  sentryDns: 'https://d1abf691806205fec480ee29f2d707df@o4508618675388416.ingest.us.sentry.io/4508619287691264',
  // TODO:PostHog試験中のため暫定プロジェクトキーを使用. 正式採用時に環境別キーを設定すること.
  posthogKey: 'phc_6UkAeE3QRE3JCCIo47WIY8zzLMNmcIdl0OtEIqhwhgq',
  posthogHost: 'https://us.i.posthog.com',
};
